import gql from "graphql-tag";

export const SAVE_ADMIN_SETTINGS = gql`
	mutation SaveAdminSettings($input: SaveAdminSettingsInput!) {
		saveAdminSettings(input: $input) {
			settings {
				id
				defaultExtractorSetId
				defaultValidatorSetId
				defaultOnChangeHandlerSetId
				defaultExporterSetId
				mailExporterSetId
				mailFromAddresses {
					id
					mailAddress
				}
			}
		}
	}
`;

export const SAVE_ADMIN_EXTRACTOR_SET = gql`
	mutation SaveAdminExtractorSet($input: SaveAdminExtractorSetInput!) {
		saveAdminExtractorSet(input: $input) {
			extractorSet {
				id
				code
				description
				extractors {
					id
					order
					extractorType
					settings
					description
				}
			}
		}
	}
`;

export const DELETE_ADMIN_EXTRACTOR_SET = gql`
	mutation DeleteAdminExtractorSet($input: DeleteAdminExtractorSetInput!) {
		deleteAdminExtractorSet(input: $input) {
			boolean
		}
	}
`;

export const SAVE_ADMIN_VALIDATOR_SET = gql`
	mutation SaveAdminValidatorSet($input: SaveAdminValidatorSetInput!) {
		saveAdminValidatorSet(input: $input) {
			validatorSet {
				id
				code
				description
				validators {
					id
					order
					validatorType
					settings
					description
				}
			}
		}
	}
`;

export const DELETE_ADMIN_VALIDATOR_SET = gql`
	mutation DeleteAdminValidatorSet($input: DeleteAdminValidatorSetInput!) {
		deleteAdminValidatorSet(input: $input) {
			boolean
		}
	}
`;

export const SAVE_ADMIN_EXPORTER_SET = gql`
	mutation SaveAdminExporterSet($input: SaveAdminExporterSetInput!) {
		saveAdminExporterSet(input: $input) {
			exporterSet {
				id
				code
				description
				exporters {
					id
					order
					code
					exporterType
					settings
					description
				}
			}
		}
	}
`;

export const DELETE_ADMIN_EXPORTER_SET = gql`
	mutation DeleteAdminExporterSet($input: DeleteAdminExporterSetInput!) {
		deleteAdminExporterSet(input: $input) {
			boolean
		}
	}
`;

export const SAVE_ADMIN_ON_CHANGE_HANDLER_SET = gql`
	mutation SaveAdminOnChangeHandlerSet($input: SaveAdminOnChangeHandlerSetInput!) {
		saveAdminOnChangeHandlerSet(input: $input) {
			onChangeHandlerSet {
				id
				code
				description
				onChangeHandlers {
					id
					order
					onChangeHandlerType
					settings
					description
				}
			}
		}
	}
`;

export const DELETE_ADMIN_ON_CHANGE_HANDLER_SET = gql`
	mutation DeleteAdminOnChangeHandlerSet($input: DeleteAdminOnChangeHandlerSetInput!) {
		deleteAdminOnChangeHandlerSet(input: $input) {
			boolean
		}
	}
`;


export const SAVE_ADMIN_LOOKUP = gql`
	mutation SaveAdminLookup($input: SaveAdminLookupInput!) {
		saveAdminLookup(input: $input) {
			lookup {
				id
				type
				code
				description
				disabled
			}
		}
	}
`;

export const DELETE_ADMIN_LOOKUP = gql`
	mutation DeleteAdminLookup($input: DeleteAdminLookupInput!) {
		deleteAdminLookup(input: $input) {
			boolean
		}
	}
`;
